import { Navigate, Route, Routes } from 'react-router';
import './App.css';
import MainLayout from './components/layout/MainLayout';
import AuthRoute from './AuthRoute';
import ProtectedRoute from './ProtectedRoute';
import LoginPage from './pages/login/LoginPage';
import DashboardPage from './pages/dashboard';
import SettingsPage from './pages/settings';
import ShippingListPage from './pages/shipping/ShippingListPage';
import CreateShippingPage from './pages/shipping/CreateShippingPage';
import ShipmentPage from './pages/shipping/ShipmentPage';

function App() {
  return (
    <div className="overflow-y-hidden">
      <MainLayout>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route 
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/shipping"
            element={
              <ProtectedRoute>
                <ShippingListPage />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/shipping/create"
            element={
              <ProtectedRoute>
                <CreateShippingPage />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/shipping/shipment"
            element={
              <ProtectedRoute>
                <ShipmentPage />
              </ProtectedRoute>
            }
          />
          {/* <Route 
            path="/groups"
            element={
              <ProtectedRoute>
                <GroupsInfoPage />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/matches"
            element={
              <ProtectedRoute>
                <MatchesPage />
              </ProtectedRoute>
            }
          /> */}
          <Route 
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/login"
            element={
              <AuthRoute>
                <LoginPage />
              </AuthRoute>
            }
          />
        </Routes>
      </MainLayout>
    </div>
  );
}

export default App;
